export default __webpack_public_path__ + "static/media/dermaheal2.4a16913c.jpg";